import * as types from './mutation-types.js'
import campaigns from '@/services/api/campaigns'
import { getDeepProperty } from '@/helpers/deepObject.js'

const state = {
  createAction: false,
  campaign: {ads: [], podcasts: []},
  campaignCount: '–',
  campaigns: [],
  targets: {}
}

const actions = {
  async associateAdToBlock ({state}, {path, payload}) {
    return campaigns.associateAd(path, payload)
  },
  clearCampaign ({state, commit}) {
    commit(types.CLEAR_CAMPAIGN)
  },
  clearCampaigns ({state, commit}) {
    commit(types.CLEAR_CAMPAIGNS)
  },
  async createCampaign ({state}, payload) {
    return campaigns.createCampaign(state.createAction, payload)
  },
  async getCampaign ({state, commit}, {id, loadAds, loadPodcasts}) {
    let result = await campaigns.getCampaign(`/campaigns/${id}`)

    commit(types.SET_CAMPAIGN, result)

    if (loadAds === true && getDeepProperty(result, 'ads.href')) {
      let ads = await campaigns.getAds(getDeepProperty(result, 'ads.href'), {fields: ['ad_id', 'type', 'audio_file_path', 'delete', 'update', 'order']})

      commit(types.SET_CAMPAIGN_ADS, ads)
    }
  },
  async getCampaignTargets ({state, commit}, id) {
    return campaigns.getCampaignTargets(`/campaigns/${id}/target_count`)
  },
  deleteAdBlock ({state, commit}, path) {
    return campaigns.deleteAdBlock(path)
      .then(async data => {
        return data
      })
      .catch(err => {
        return err
      })
  },
  deleteCampaign ({state, commit}, campaignId) {
    return campaigns.deleteCampaign(campaignId)
      .then(async data => {
        return data
      })
      .catch(err => {
        return err
      })
  },
  async getCampaigns ({state, commit}, {options, accountId}) {
    let result = {}
    if (!accountId) {
      result = await campaigns.getCampaigns(options)
    } else {
      result = await campaigns.getAccountCampaigns(options, accountId)
    }
    commit(types.SET_CAN_CREATE_CAMPAIGN, result)
    commit(types.SET_CAMPAIGN_LIST, result.collection)
    commit(types.SET_CAMPAIGN_COUNT, result.count)
    return result
  },
  async getTargets ({state, commit}, {campaignId, accountId}) {
    let result = await campaigns.getTargets(campaignId, accountId)

    commit(types.SET_TARGET_LIST, result.collection)
  },
  async getCPM ({state, commit}, id) {
    let result = await campaigns.getCPM(id)

    return result.total
  },
  async updateAdBlock ({state}, {path, payload}) {
    return await campaigns.updateAdBlock(path, payload)
  },
  async updateCampaign ({state, commit}, {payload, id, loadAds}) {
    let result = await campaigns.updateCampaign(id, payload)

    commit(types.SET_CAMPAIGN, result)

    if (loadAds === true && getDeepProperty(result, 'ads.href')) {
      let ads = await campaigns.getAds(getDeepProperty(result, 'ads.href'), {fields: ['ad_id', 'type', 'audio_file_path', 'delete', 'update', 'order']})

      commit(types.SET_CAMPAIGN_ADS, ads)
    }

    return result
  }
}

const mutations = {
  [types.CLEAR_CAMPAIGN] (state) {
    state.campaign = {ads: [], podcasts: []}
  },
  [types.CLEAR_CAMPAIGNS] (state) {
    state.campaigns = []
    state.targets = {}
  },
  [types.CLEAR_CAMPAIGN_PODCASTS] (state) {
    state.campaign.podcasts = []
  },
  [types.SET_CAMPAIGN] (state, campaign) {
    state.campaign = {...campaign, ...{}}
    state.campaign.ads = []
    state.campaign.podcasts = []
  },
  [types.SET_CAMPAIGN_ADS] (state, ads) {
    state.campaign.ads = ads
  },
  [types.SET_CAMPAIGN_LIST] (state, campaigns) {
    state.campaigns = campaigns
  },
  [types.SET_CAMPAIGN_COUNT] (state, count) {
    state.campaignCount = count
  },
  [types.SET_CAN_CREATE_CAMPAIGN] (state, campaign) {
    state.createAction = getDeepProperty(campaign, 'create.action')
  },
  [types.SET_TARGET_LIST] (state, targets) {
    state.targets = targets
  }
}

const getters = {
  campaign: state => state.campaign,
  campaignCount: state => state.campaignCount,
  campaigns: state => state.campaigns,
  targets: state => state.targets
}

export default {
  state,
  actions,
  mutations,
  getters
}
